import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../../../data/Axios/DynamicForm";
import { executeAnyMutation, fetchJsonDynamic } from "../../../../../data/DynamicServiceNew/jsondynamicservice";
import { customerservice, setupManagementUrl,  loanManagementUrl,
 } from "../../../../../config";
import { guarantorFields } from "../../../../../data/DynamicForm/FormFields/CustomerFormFields";

const base_url = customerservice.uri;
const setup_url = setupManagementUrl.uri;
const loan_url = loanManagementUrl.uri;

const GuarantorForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const customerId = parseInt(localStorage.getItem("CustomerId"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
  const [loading, setLoading] = useState(true);
  const [maritalStatusData, setMaritalStatustData] = useState([]);
  const [customerRelationshipData, setCustomerRelationshipData] = useState([]);
  const [requireGuarantorImages, setRequireGuarantorImages] = useState(false);

  const [formData, setFormData] = useState({
    idFrontPhoto: null,
    idBackPhoto: null,
    photo: null,
  });

  useEffect(() => {
    async function fetchAllData() {
      try {
        const maritalStatusDataResponse = await fetchJsonDynamic(
          "allMaritalStatus",
          null,
          null,
          setup_url
        );
        const customerRelationshipsResponse = await fetchJsonDynamic(
          "allCustomerRelationships",
          null,
          null,
          setup_url
        );
        if (customerRelationshipsResponse?.results) {
          const result = JSON.parse(customerRelationshipsResponse?.results);
          setCustomerRelationshipData(result || []);
        }
        if (maritalStatusDataResponse?.results) {
          const results = JSON.parse(maritalStatusDataResponse?.results);
          setMaritalStatustData(results || []);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAllData();
  }, []);
  useEffect(() => {
  async function fetchLoanSettings() {
    try {
      const response = await fetchJsonDynamic(
        "loanSettings",
        null,
        null,
        loan_url
      );

      if (response?.results) {
        const settings = JSON.parse(response.results);

        const guarantorImagesSetting = settings.find(
          (s) => s.Setting === "Require Gurantor Images"
        );

        const isRequired =
          guarantorImagesSetting?.Value?.toString().toLowerCase() === "true";

        setRequireGuarantorImages(isRequired);

        console.log(
          "Require Guarantor Images:",
          guarantorImagesSetting?.Value,
          "=>",
          isRequired
        );
      }
    } catch (error) {
      console.error("Error fetching guarantor image setting:", error);

      // Safe default: images are not mandatory if setting cannot be fetched
      setRequireGuarantorImages(false);
    }
  }

  fetchLoanSettings();
}, []);

  const maritalStatusOptions = maritalStatusData.map((status) => ({
    value: status.Id,
    label: status.Name,
  }));
  const customerRelationshipOptions = customerRelationshipData.map((relation) => ({
    value: relation.Id,
    label: relation.Name,
  }));

  const formatDate = (date) => {
    if (!date) return null;
    return date.split("T")[0];
  };

  const initialValues = {
    id: props.data ? props.data.Id : "",
    relationshipToLoanee: props.data ? props.data.Relationshiptoloaneeid: "",
    firstName: props.data ? props.data.FirstName : "",
    otherNames: props.data ? props.data.OtherNames : "",
    mobileNumber: props.data ? props.data.MobileNumber : "",
    idNoOrPassport: props.data ? props.data.IdnoOrPassport : "",
    maritalStatus: props.data ? props.data.Maritalstatusid : "",
    dob: props.data ? formatDate(props.data.Dob) : null,
    currentResidence: props.data ? props.data.Currentresidence : "",
    permanentResidence: props.data ? props.data.PermanentResidence: "",
    town: props.data ? props.data.Town : "",
    houseName: props.data ? props.data.HouseName : "",
    floorNumber: props.data ? props.data.FloorNumber : "",
    roomNumber: props.data ? props.data.RoomNumber : "",
    occupation: props.data ? props.data.Occupation : "",
    photo: props.data ? props.data.Photo : "",
    idFrontPhoto: props.data ? props.data.IdfrontPhoto : "",
    idBackPhoto: props.data ? props.data.IdbackPhoto : "",
  };

  const resizeImage = (file, maxWidth = 800, maxHeight = 800, quality = 0.7) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          let width = img.width;
          let height = img.height;

          if (width > maxWidth || height > maxHeight) {
            if (width > height) {
              height *= maxWidth / width;
              width = maxWidth;
            } else {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          canvas.toBlob(
            (blob) => resolve(blob),
            "image/png",
            quality
          );
        };
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const convertFileToBase64 = (file) => {
    if (!file) return null;
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result.split(",")[1]);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };
  const handleFileChange = async (fieldName, file, setFieldValue) => {
    if (file) {
      try {
        console.log(`Handling file change for ${fieldName}: ${file.name}`);
        const resizedFile = await resizeImage(file);
        const base64String = await convertFileToBase64(resizedFile);
        setFormData((prev) => {
          const updatedFormData = {
            ...prev,
            [fieldName]: base64String,
          };
          console.log("Updated formData:", updatedFormData);
          return updatedFormData;
        });
        // Optionally sync with Formik values (if needed for validation/display)
        setFieldValue(fieldName, file); // Store the File object in Formik values
      } catch (error) {
        console.error(`Error processing file for ${fieldName}:`, error);
      }
    }
  };

  const forms = [
    {
      name: "maritalStatus",
      label: "Marital Status",
      type: "select",
      options: maritalStatusOptions,
      gridColumn: "span 2",
      required: false,
    },
    {
      name: "relationshipToLoanee",
      label: "Relationship",
      type: "select",
      options: customerRelationshipOptions,
      gridColumn: "span 2",
      required: false,
    },
    ...guarantorFields.map((f) =>
      ["idNoOrPassport", "mobileNumber"].includes(f.name)
        ? {
            ...f,
            onBlur: (e, setFieldValue, values, setFieldError) => {
              checkGuarantorDuplicate(f.name, e.target.value, setFieldError);
            },
          }
        : f
    ),
    {
      name: "idFrontPhoto",
      label: "ID Front Photo",
      type: "file",
      accept: "image/*",
      gridColumn: "span 2",
      required: requireGuarantorImages,
      onChangeHandler: (e) =>
        handleFileChange("idFrontPhoto", e.target.files[0]),
    },
    {
      name: "idBackPhoto",
      label: "ID Back Photo",
      type: "file",
      accept: "image/*",
      gridColumn: "span 2",
      required: requireGuarantorImages,
      onChangeHandler: (e) =>
        handleFileChange("idBackPhoto", e.target.files[0]),
    },
    {
      name: "photo",
      label: "Selfie Photo",
      type: "file",
      accept: "image/*",
      gridColumn: "span 2",
      required: requireGuarantorImages,
      onChangeHandler: (e) =>
        handleFileChange("photo", e.target.files[0]),
    },
  ];

  // const checkGuarantorDuplicate = async (fieldName, value, setFieldError) => {
  //   const term = value ? value.trim() : "";
  //   if (!term) {
  //     setFieldError(fieldName, undefined);
  //     return;
  //   }
  //   try {
  //     const variables = { [fieldName]: term };
  //     if (props.isEditing && props.data?.Id) {
  //       variables.id = props.data.Id;
  //     }
  //     const response = await fetchJsonDynamic(
  //       "guarantorDuplicateCheck",
  //       "guarantor",
  //       variables,
  //       base_url
  //     );
  //     if (response?.results) {
  //       const parsed = JSON.parse(response.results);
  //       setFieldError(fieldName, parsed?.exists ? parsed.message : undefined);
  //     }
  //   } catch (error) {
  //     console.error(`Error checking duplicate for ${fieldName}:`, error);
  //   }
  // };
  const checkGuarantorDuplicate = async (fieldName, value, setFieldError) => {
  const term = value ? value.trim() : "";
  if (!term) {
    setFieldError(fieldName, undefined);
    return;
  }
  try {
    const variables = { [fieldName]: term, customerId };
    if (props.isEditing && props.data?.Id) {
      variables.id = props.data.Id;
    }
    const response = await fetchJsonDynamic(
      "guarantorDuplicateCheck",
      "guarantor",
      variables,
      base_url
    );
    if (response?.results) {
      const parsed = JSON.parse(response.results);
      setFieldError(fieldName, parsed?.exists ? parsed.message : undefined);
    }
  } catch (error) {
    console.error(`Error checking duplicate for ${fieldName}:`, error);
  }
};

  const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    try {
      const {
        relationshipToLoanee,
        firstName,
        otherNames,
        mobileNumber,
        idNoOrPassport,
        maritalStatus,
        dob,
        currentResidence,
        permanentResidence,
        town,
        houseName,
        floorNumber,
        roomNumber,
        occupation,
        idFrontPhoto,
        idBackPhoto,
        photo,
      } = values;

      const idFrontPhotoBase64 = formData.idFrontPhoto || (props.isEditing ? props.data.IdFrontPhoto : null);
      const idBackPhotoBase64 = formData.idBackPhoto || (props.isEditing ? props.data.IdBackPhoto : null);
      const selfiePhotoBase64 = formData.photo || (props.isEditing ? props.data.Photo : null);

      const mutationData = {
        relationshipToLoanee: parseInt(relationshipToLoanee),
        firstName,
        otherNames,
        mobileNumber,
        idNoOrPassport,
        maritalStatus: parseInt(maritalStatus),
        dob,
        currentResidence,
        permanentResidence,
        town,
        houseName,
        floorNumber,
        roomNumber,
        occupation,
        customerId,
        idFrontPhoto: idFrontPhotoBase64 || null,
        idBackPhoto: idBackPhotoBase64 || null,
        photo: selfiePhotoBase64 || null,
      };

      if (props.isEditing) {
        mutationData.id = props.data.Id;
      }

      const response = await executeAnyMutation(
        props.isEditing ? "updateGuarantor" : "createGuarantor",
        mutationData,
        "guarantor",
        false,
        base_url
      );

      if (response.results) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Guarantor ${props.isEditing ? "updated" : "created"} successfully.`,
        });
      } else if (response.error) {
        let errorMessage = "An unknown error occurred.";
        try {
          const errorObj = typeof response.error === "string" ? JSON.parse(response.error) : response.error;
          if (typeof errorObj === "string") {
            errorMessage = errorObj;
          } else if (errorObj?.error) {
            errorMessage = errorObj.error;
          } else if (errorObj?.Error) {
            errorMessage = errorObj.Error.match(/System\.Exception: (.*?)\./)?.[1] || errorObj.Error;
          }
        } catch (err) {
          errorMessage = response.error;
        }

        if (errorMessage.includes("already registered to customer")) {
          const fieldName = errorMessage.startsWith("Mobile Number")
            ? "mobileNumber"
            : "idNoOrPassport";
          setFieldError(fieldName, errorMessage);
          setSubmitting(false);
          return;
        }

        Swal.fire({
          icon: "error",
          title: "Error!",
          text: errorMessage || "An error occurred while processing your request.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
    setSubmitting(false);
  };

  if (loading) return <CircularProgress />;

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={forms}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit Guarantor" : "Create Guarantor"}
      subtitle={props.isEditing ? "Edit an Existing Guarantor" : "Create a Guarantor"}
    />
  );
};

export default GuarantorForm;